import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {getFormData} from "../../models/domainModel";
import {domainSchema} from "../../schema/domainSchema";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {createDomain} from "../../store/domain-slice";

const DomainAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {
        createStatus,
        error
    } = useSelector(state => state.domain);

    useEffect(() => {
        if (createStatus === "success") {
            navigator("..");
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        dispatch(createDomain(data));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = domainSchema(); // Updated schema
    const initialData = getFormData(); // Now from employee model
    return (
        <>
            <SubHeader title="Add Domain">
                <Button to=".." className="bg-primary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default DomainAdd;